import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DealersListResp } from "components/DealersAndLocationsDropdown/queryKeys";

const getDealerLocations = (allDealers: DealersListResp) => allDealers.dealers.flatMap(dealer => dealer.locations || []);

export const usePermanentLocations = () => {
  return {
    locations:
      useTypedQuery({
        queryKey: DealersAndLocationsDropdownKeys.dealers,
        queryFn: async ({ endpoint, params, baseUrl }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
        select: getDealerLocations
      }).data || []
  };
};
